import React from "react";
import "./skeleton.css";

interface Props {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  className?: string;
}

function Skeleton({
  width,
  height = 16,
  borderRadius = "var(--radius-sm)",
  className = "",
}: Props) {
  return (
    <div
      className={`sk-block ${className}`}
      style={{
        width:
          width == null
            ? "100%"
            : typeof width === "number"
              ? `${width}px`
              : width,
        height: typeof height === "number" ? `${height}px` : height,
        borderRadius:
          typeof borderRadius === "number" ? `${borderRadius}px` : borderRadius,
      }}
    />
  );
}

export default Skeleton;
